import React from "react";

/** The AcreLatch brand mark — raster logo (navy barn + rust furrows).
 *
 * Props:
 *   size   — rendered pixel size (default 32)
 *   className — extra Tailwind classes (positioning, borders, etc.)
 */
export default function Logo({ size = 32, className = "" }) {
  return (
    <img
      src="/acrelatch-logo.png"
      alt="AcreLatch"
      width={size}
      height={size}
      className={`inline-block object-contain ${className}`}
      data-testid="acrelatch-logo"
    />
  );
}
